export const site = {
  name: "吃瓜日报",
  brandEn: "ChiGua Daily",
  tagline: "网红吃瓜 · 今日瓜新鲜速递",
  description:
    "吃瓜日报专注网红圈今日瓜与最新爆料，用事件时间线和聊天记录还原，把零散瓜料整理成 5 分钟能看懂的完整脉络。",
  email: "hello@chiguadaily.example.com",
  tipEmail: "tips@chiguadaily.example.com",
  since: "2023",
  stats: [
    { label: "累计整理瓜料", value: "12,600+" },
    { label: "日均围观人次", value: "38万" },
    { label: "覆盖网红事件", value: "2,140 起" },
    { label: "平均成稿时长", value: "42 分钟" },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "今日瓜", to: "/news" },
  { label: "热门专题", to: "/topic/love" },
  { label: "关于我们", to: "/about" },
];

export const categories = [
  {
    slug: "love",
    name: "恋爱八卦",
    desc: "官宣、分手、互撕，情感线一网打尽",
    count: 342,
  },
  {
    slug: "collapse",
    name: "人设塌房",
    desc: "被扒、被锤、被质疑，人设反转现场",
    count: 268,
  },
  {
    slug: "livestream",
    name: "直播翻车",
    desc: "直播间里的失控瞬间与名场面",
    count: 197,
  },
  {
    slug: "selling",
    name: "带货争议",
    desc: "选品、价格、售后，带货背后的争议",
    count: 233,
  },
  {
    slug: "variety",
    name: "综艺热点",
    desc: "综艺同框、剪辑内幕与名场面复盘",
    count: 154,
  },
  {
    slug: "business",
    name: "网红创业",
    desc: "自创品牌、团队运作与商业版图观察",
    count: 128,
  },
];

export const topics = [
  {
    slug: "love",
    title: "恋爱瓜观察室",
    desc: "把官宣、分手、互撕的时间线一次理清，谁先动的手、谁先删的博，一目了然。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20illustration%20of%20two%20intertwined%20hearts%20made%20of%20paper%20collage%2C%20coral%20red%20and%20cream%20color%20palette%2C%20soft%20grain%20texture%2C%20magazine%20cover%20art%2C%20clean%20warm%20background&width=800&height=600&seq=cg-topic-love&orientation=landscape",
    articleCount: 86,
  },
  {
    slug: "collapse",
    title: "塌房现场复盘",
    desc: "从第一张聊天记录到官方回应，逐帧还原人设崩塌的完整过程。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20art%20of%20a%20cracked%20porcelain%20mask%20on%20a%20cream%20backdrop%2C%20editorial%20collage%20style%2C%20muted%20terracotta%20and%20sage%20green%2C%20subtle%20paper%20texture%2C%20minimal%20magazine%20illustration&width=800&height=600&seq=cg-topic-collapse&orientation=landscape",
    articleCount: 72,
  },
  {
    slug: "livestream",
    title: "直播间名场面",
    desc: "怒摔话筒、连麦对喷、临时下播，直播事故的高光时刻合集。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20retro%20microphone%20with%20sound%20waves%20on%20a%20warm%20amber%20background%2C%20editorial%20collage%20art%2C%20grain%20texture%2C%20minimal%20magazine%20poster%20style&width=800&height=600&seq=cg-topic-live&orientation=landscape",
    articleCount: 61,
  },
  {
    slug: "selling",
    title: "带货争议档案",
    desc: "选品翻车、价格猫腻与售后拉扯，带货链条上的每一次争议。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20art%20of%20a%20shopping%20bag%20and%20price%20tag%20in%20paper%20collage%20style%2C%20coral%20and%20sand%20tones%2C%20warm%20textured%20background%2C%20minimal%20magazine%20illustration&width=800&height=600&seq=cg-topic-selling&orientation=landscape",
    articleCount: 58,
  },
  {
    slug: "variety",
    title: "综艺同框内幕",
    desc: "谁被剪了、谁抢了镜头，综艺成片背后的那些取舍。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20stacked%20film%20frames%20and%20a%20clapperboard%20on%20a%20cream%20background%2C%20editorial%20collage%20art%2C%20coral%20red%20accents%2C%20grain%20texture%2C%20minimal%20poster%20style&width=800&height=600&seq=cg-topic-variety&orientation=landscape",
    articleCount: 44,
  },
  {
    slug: "business",
    title: "网红商业版图",
    desc: "自创品牌、MCN 签约与团队运作，网红生意的真实一面。",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20art%20of%20ascending%20geometric%20blocks%20with%20a%20small%20plant%20sprout%2C%20sage%20green%20and%20cream%20palette%2C%20paper%20collage%2C%20warm%20textured%20background%20magazine%20illustration&width=800&height=600&seq=cg-topic-biz&orientation=landscape",
    articleCount: 39,
  },
];

export const articles = [
  {
    id: "cg-20260910-01",
    slug: "food-blogger-couple-script",
    title: "千万粉美食博主被曝情侣剧本，聊天记录流出后连夜删博",
    summary:
      "一对以「异地恋情侣」人设走红的美食博主被前团队成员爆料，称两人早在半年前已经分手，视频中的甜蜜互动由脚本安排。爆料还附上了几段疑似工作群的聊天记录。",
    category: "love",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20of%20two%20paper%20cut%20figures%20dining%20together%20with%20a%20phone%20screen%2C%20coral%20red%20and%20cream%20palette%2C%20soft%20grain%2C%20warm%20minimal%20background%2C%20magazine%20illustration&width=1200&height=800&seq=cg-art-01&orientation=landscape",
    author: "瓜田观察员",
    publishedAt: "2026-09-10 09:20",
    views: 428000,
    hot: true,
    tags: ["情侣剧本", "聊天记录", "今日瓜"],
    timeline: [
      { time: "09-09 22:40", text: "前团队成员在社交平台发布长文，称两人已分手半年。" },
      { time: "09-09 23:15", text: "数张疑似工作群聊天记录被公开，提到「这周脚本按情侣方向写」。" },
      { time: "09-10 01:02", text: "两人合拍账号删除近三个月内 11 条情侣主题视频。" },
      { time: "09-10 09:20", text: "账号发布简短说明，称内容调整属于正常规划，未回应分手传闻。" },
    ],
    content: [
      "这对以「异地恋 + 家常菜」走红的美食博主，在过去两年里靠固定的互动模式积累了千万级粉丝。视频里，男生负责做菜，女生负责吐槽，结尾总会有一段两人视频通话的镜头。这套结构稳定、节奏统一的内容，也一直被粉丝称作「电子下饭菜」。",
      "但昨晚一则来自前团队成员的爆料，让这套稳定结构出现了裂缝。爆料者称，两人实际在半年前就已经和平分开，之后所有情侣向内容都由脚本与分镜安排完成，通话镜头也多为补拍。",
      "随爆料一同流出的，还有几段疑似工作群的聊天记录。记录中出现了「本月四条情侣向」「分手线先不要碰」等表述，语气更接近内容排期而非私人对话。目前这些记录的真实性尚未得到第三方确认。",
      "截至今天上午，两人合拍账号已删除近三个月内 11 条情侣主题视频，商业合作内容的评论区也陆续关闭。账号运营方仅发布了一句简短说明，称内容调整属于正常规划，并未正面回应分手传闻。",
      "值得注意的是，该账号近半年新增的商业合作明显偏向家居与厨具品类，情侣人设正是这类品牌最看重的标签。有营销从业者分析，如果人设信息与真实关系不符，已经签约的品牌方可能会重新评估后续投放。",
      "截至发稿，双方均未公布进一步的证据或说明。事件后续走向，我们会持续跟进。",
    ],
    related: ["cg-20260907-07", "cg-20260906-03", "cg-20260905-05"],
  },
  {
    id: "cg-20260910-02",
    slug: "top-livestreamer-apology",
    title: "直播间怒摔话筒后，头部带货主播深夜发文道歉",
    summary:
      "一场原定四小时的带货直播在开播第七十分钟被中断。主播因选品被质疑而当众摔话筒下播，随后于凌晨发布道歉长文，称情绪管理出了问题。",
    category: "livestream",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20fallen%20studio%20microphone%20and%20scattered%20price%20tags%20on%20a%20warm%20amber%20background%2C%20editorial%20collage%20art%2C%20grain%20texture%2C%20minimal%20magazine%20poster&width=1200&height=800&seq=cg-art-02&orientation=landscape",
    author: "值班小编",
    publishedAt: "2026-09-10 07:45",
    views: 316000,
    hot: true,
    tags: ["直播事故", "道歉", "选品"],
    timeline: [
      { time: "09-09 20:10", text: "直播按计划开播，主打家居清洁专场。" },
      { time: "09-09 21:20", text: "弹幕集中质疑某款清洁剂价格高于日常渠道。" },
      { time: "09-09 21:26", text: "主播回应时语气升高，摔下话筒，直播画面中断。" },
      { time: "09-10 02:30", text: "主播发布道歉长文，承认情绪管理不到位，承诺重新核对选品。" },
    ],
    content: [
      "昨晚的这场直播原本是一次常规的家居清洁专场，四小时的排期里安排了二十余款商品。开播第七十分钟，评论区开始集中出现关于某款清洁剂价格的质疑。",
      "面对滚动刷屏的弹幕，主播先是以「渠道不同」回应，随后语速明显加快，在留下一句「今天就到这里」之后摔下话筒离席，直播画面随即中断。整个过程不到三十秒，被大量观众录屏转发。",
      "凌晨两点半，主播在个人账号发布道歉长文。文中承认自己在压力下情绪管理不到位，并对当晚的选品流程作出承诺：所有上架商品的价格将重新与主流渠道比对，差价部分将做退款处理。",
      "有长期合作的品牌方表示，理解直播中的情绪波动，但更关心后续的价格机制是否透明。也有观众认为，一次道歉不足以解决问题，希望看到更具体的选品标准公开。",
      "从行业角度看，带货直播的信任成本越来越高。价格比对、售后响应与话术规范，任何一环出问题都会被放大成公共事件。这场直播事故，或许给所有从业者提了个醒。",
    ],
    related: ["cg-20260908-05", "cg-20260904-10", "cg-20260903-09"],
  },
  {
    id: "cg-20260909-03",
    slug: "variety-friendship-cut",
    title: "综艺同框被剪引发取关，两位网红的三个月互动梳理",
    summary:
      "一档生活类综艺播出后，观众发现两位此前互动频繁的网红在成片中几乎零交流，节目播出当晚双方互相取关，引发关于剪辑与关系的讨论。",
    category: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20of%20split%20film%20frames%20with%20two%20silhouettes%20facing%20away%2C%20cream%20and%20coral%20palette%2C%20paper%20texture%2C%20minimal%20magazine%20illustration&width=1200&height=800&seq=cg-art-03&orientation=landscape",
    author: "瓜田观察员",
    publishedAt: "2026-09-09 18:30",
    views: 187000,
    hot: false,
    tags: ["综艺剪辑", "取关", "同框"],
    timeline: [
      { time: "06-15", text: "两人首次在公开活动同台，互相关注并互动。" },
      { time: "08-20", text: "综艺官宣阵容，两人被分到同一组。" },
      { time: "09-08 20:00", text: "节目首播，成片中两人同组镜头不足两分钟。" },
      { time: "09-08 22:40", text: "网友发现双方已互相取关，相关话题登上热搜。" },
    ],
    content: [
      "这档生活类综艺的看点之一，就是把几位不同领域的博主放到同一屋檐下生活三天。开播前的宣传物料里，两位网红的互动片段被反复使用，也让观众对她们的同框充满期待。",
      "然而首播成片中，两人同组镜头合计不足两分钟，多数对话只留下背影与画外音。这样的差异让不少观众在弹幕里追问「发生了什么」。",
      "节目播出当晚十点四十左右，有网友发现两人在社交平台互相取关，此前互相转发的动态也已不可见。相关话题很快冲上热搜前列。",
      "节目组暂未就此回应。一位不愿具名的综艺剪辑师表示，成片镜头选择通常要同时考虑时长、叙事线和嘉宾状态，「零交流」可能是真实素材不足，也可能是刻意的叙事取舍。",
      "无论原因如何，观众对综艺真实感的期待与现实剪辑逻辑之间的落差，才是这类话题反复出现的根源。",
    ],
    related: ["cg-20260906-09", "cg-20260905-10", "cg-20260902-08"],
  },
  {
    id: "cg-20260908-04",
    slug: "craftsman-team-expose",
    title: "「乡村手艺人」人设崩塌？被指全程团队包装",
    summary:
      "一位以手作木器走红的博主，被指视频中的「乡村小院」实为租用场地，作品由工厂代工。博主回应称团队协助属实，但工艺确实是自己的。",
    category: "collapse",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20art%20of%20hand%20tools%20and%20wood%20shavings%20on%20a%20cream%20background%2C%20sage%20green%20and%20terracotta%20accents%2C%20paper%20collage%20texture%2C%20minimal%20magazine%20illustration&width=1200&height=800&seq=cg-art-04&orientation=landscape",
    author: "深扒小组",
    publishedAt: "2026-09-08 15:10",
    views: 254000,
    hot: true,
    tags: ["人设", "代工", "回应"],
    timeline: [
      { time: "09-07 11:00", text: "网友发帖对比视频场地与某影视基地布景，指出高度相似。" },
      { time: "09-07 16:30", text: "供应商方面流出的订单截图显示，部分成品来自批量代工。" },
      { time: "09-08 10:20", text: "博主发布视频回应，承认有团队协助拍摄与选品。" },
      { time: "09-08 15:10", text: "多个合作品牌将产品页中的「手作」字样改为「原创设计」。" },
    ],
    content: [
      "这位博主最初靠一条「一个人在山里做木勺」的视频走红。镜头里的泥土院墙、柴火灶台和手上的木屑，构成了观众对「乡村手艺人」的全部想象。",
      "转折来自一条对比帖。发帖者把视频中的院墙、门框与某影视基地的布景照片并列，指出结构高度一致，并称该场地按天出租。",
      "紧接着，又有供应商方面的订单截图流出，显示其中的收纳木盒等产品为批量代工。这与视频里「纯手工、每件都不一样」的表述形成了明显反差。",
      "博主在次日发布回应视频。他承认从去年开始就有团队协助拍摄、选品与供应链对接，但坚持核心的木作工艺仍由自己完成，并展示了部分工作过程。",
      "争议并没有随着回应结束。多个合作品牌在当天下午把商品页里的「手作」字样换成了更模糊的「原创设计」，这一动作被解读为品牌方的风险规避。",
      "人设类内容的核心矛盾在于：观众为「真实」付费，而规模化的内容生产天然需要团队。如何在两者之间找到诚实的表达方式，是这类创作者必须回答的问题。",
    ],
    related: ["cg-20260907-09", "cg-20260902-01", "cg-20260901-06"],
  },
  {
    id: "cg-20260908-05",
    slug: "lucky-bag-cost-dispute",
    title: "9.9 元福袋成本不到 1 元，带货选品再惹争议",
    summary:
      "有消费者晒出拆袋视频，称 9.9 元的福袋内商品与宣传图差距明显。第三方比价显示，同款商品在批发渠道单价不足 1 元。",
    category: "selling",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20small%20paper%20gift%20bag%20with%20price%20tag%20and%20receipt%20on%20sand%20colored%20background%2C%20editorial%20collage%2C%20coral%20accents%2C%20grain%20texture%2C%20minimal%20magazine%20art&width=1200&height=800&seq=cg-art-05&orientation=landscape",
    author: "值班小编",
    publishedAt: "2026-09-08 10:05",
    views: 143000,
    hot: false,
    tags: ["福袋", "选品", "售后"],
    timeline: [
      { time: "09-06", text: "消费者陆续晒出福袋拆袋视频，实际商品与宣传图不符。" },
      { time: "09-07", text: "第三方比价显示同款商品批发单价低于 1 元。" },
      { time: "09-08 09:00", text: "主播团队回应称福袋为随机组合，已开放无理由退款。" },
      { time: "09-08 10:05", text: "平台方面表示正在核查相关商品与宣传素材。" },
    ],
    content: [
      "福袋一直是直播间拉动下单率的常规手段：低价、随机、有惊喜感。但随机性也意味着预期管理的难度更高。",
      "这次的争议来自一批拆袋视频。多位消费者表示，实际收到的商品与直播间展示的示意图差距较大，部分商品包装简陋、实用性有限。",
      "随后有比价博主对同款商品做了渠道核查，发现其中几件在批发平台的单价不足 1 元，如果按此计算，福袋的物料成本远低于售价。",
      "主播团队在次日回应称，福袋本身就是随机组合，宣传图仅为效果示意，并已为不满意的消费者开放无理由退款通道。",
      "平台方面表示正在核查相关商品与宣传素材是否合规。有消费者权益从业者提醒，随机商品同样需要如实描述，示意图与实物明显不符可能构成误导。",
      "低价福袋的商业模式本身没有问题，问题出在宣传物料与实际交付之间的信任落差。",
    ],
    related: ["cg-20260910-02", "cg-20260904-10", "cg-20260901-06"],
  },
  {
    id: "cg-20260907-06",
    slug: "blogger-brands-survival",
    title: "从内容到品牌：三位网红自创品牌的两年生存现状",
    summary:
      "过去两年，多位头部网红推出了自己的服饰与美妆品牌。热闹的开局之后，真正留下来的是哪些？我们复盘了三个案例的完整路径。",
    category: "business",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20art%20of%20stacked%20geometric%20product%20boxes%20and%20a%20rising%20arrow%20shape%2C%20sage%20green%20and%20cream%20palette%2C%20paper%20collage%20texture%2C%20warm%20background%2C%20minimal%20magazine%20illustration&width=1200&height=800&seq=cg-art-06&orientation=landscape",
    author: "商业观察组",
    publishedAt: "2026-09-07 14:20",
    views: 96000,
    hot: false,
    tags: ["自创品牌", "商业", "复盘"],
    timeline: [
      { time: "2024-03", text: "第一位博主上线服饰品牌，首批发售即售罄。" },
      { time: "2025-01", text: "第二位博主上线美妆线，主打成分与平价。" },
      { time: "2025-11", text: "第三位博主转做生活方式集合店，从线上走到线下。" },
      { time: "2026-09", text: "三个品牌的复购表现出现明显分化。" },
    ],
    content: [
      "网红做品牌，第一步往往非常顺利。粉丝基础意味着冷启动成本极低，一次直播就能完成首批库存的清空。",
      "但第二批、第三批货才是真正的考验。第一位博主的服饰品牌在首次售罄后，因供应链响应速度不足，第二批交付延迟了近一个月，口碑出现波动。",
      "第二位博主选择美妆赛道，主打成分透明与平价。她保留了大量关于配方和检测的内容输出，把科普做成品牌资产，复购率在三个案例中表现最好。",
      "第三位博主则走向线下，把内容里反复出现的生活场景做成了集合店，卖的不只是商品，也是一种生活方式的想象。这条路更慢，但用户的停留时间更长。",
      "三个案例说明，粉丝可以带来第一次购买，留住人的仍然是产品本身与交付体验。把流量转化为品牌，需要的是长期的供应链能力和清晰的产品逻辑。",
    ],
    related: ["cg-20260905-05", "cg-20260903-09", "cg-20260901-06"],
  },
  {
    id: "cg-20260907-07",
    slug: "breakup-timeline-three-months",
    title: "分手声明互撕，时间线还原这对网红情侣的三个月",
    summary:
      "从高调官宣到互发声明，这对网红情侣只用了三个月。双方各执一词，我们把公开动态按时间排了一遍。",
    category: "love",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20collage%20of%20a%20torn%20paper%20heart%20and%20timeline%20dots%2C%20coral%20red%20and%20cream%20palette%2C%20grain%20texture%2C%20warm%20minimal%20background%2C%20magazine%20illustration&width=1200&height=800&seq=cg-art-07&orientation=landscape",
    author: "瓜田观察员",
    publishedAt: "2026-09-07 09:15",
    views: 209000,
    hot: true,
    tags: ["分手", "时间线", "声明"],
    timeline: [
      { time: "06-12", text: "两人发布合拍视频首次官宣，评论区一片祝福。" },
      { time: "07-28", text: "女方直播中提到「最近沟通有点少」，随后话题被切走。" },
      { time: "08-30", text: "两人合拍账号停更，商业合作内容下架。" },
      { time: "09-06 21:00", text: "双方先后发布声明，就分手原因与账号归属产生分歧。" },
    ],
    content: [
      "六月官宣、九月互撕，这对网红情侣的关系周期短得让粉丝措手不及。两人的合拍账号在官宣后的一个月里涨粉近百万，是当时同类型账号里数据最好的一对。",
      "转折出现在七月末。女方在一次直播中提到「最近沟通有点少」，语气平淡，但很快被搭档用话题岔开。这段十几秒的片段后来被反复截取讨论。",
      "八月三十日，合拍账号停更。原本置顶的三条商业合作视频下架，评论区也被关闭。此时外界开始出现分手的猜测。",
      "九月六日晚九点，双方先后发布声明。女方称关系结束是双方共同决定，主要原因是长期异地；男方则在声明中提到账号归属与收益分配尚未谈妥。",
      "两份声明的语气并不一致，也让「共同决定」这个说法打了折扣。账号归属问题涉及已签约的多项商业合作，短期内恐怕难以和平收尾。",
      "对围观者来说，这是一个关于「把感情做成内容」的典型案例。当私人关系成为账号资产，分手就不再只是两个人的事。",
    ],
    related: ["cg-20260910-01", "cg-20260906-03", "cg-20260902-01"],
  },
  {
    id: "cg-20260906-08",
    slug: "livestream-argument-two-hours",
    title: "连麦对喷两小时，主播圈这场骂战到底谁占理",
    summary:
      "两位主播因一条剪辑视频产生矛盾，在深夜连麦对峙近两小时。围观人数一度突破二十万，双方各执一词。",
    category: "livestream",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20two%20overlapping%20speech%20bubbles%20with%20lightning%20shapes%2C%20amber%20and%20cream%20palette%2C%20editorial%20collage%20art%2C%20grain%20texture%2C%20minimal%20magazine%20poster&width=1200&height=800&seq=cg-art-08&orientation=landscape",
    author: "值班小编",
    publishedAt: "2026-09-06 23:40",
    views: 178000,
    hot: false,
    tags: ["连麦", "骂战", "剪辑"],
    timeline: [
      { time: "09-05", text: "一段被恶意剪辑的片段在多个社群传播。" },
      { time: "09-06 22:00", text: "两位主播开启连麦，就剪辑与言论展开对峙。" },
      { time: "09-06 23:30", text: "在线围观人数突破二十万，相关话题冲上榜单。" },
      { time: "09-07 01:00", text: "双方先后下播，均未达成一致。" },
    ],
    content: [
      "这场连麦的起点其实很小：一段只有十几秒的剪辑视频。视频截取了其中一位主播直播中的半句话，配上字幕后在多个社群传播，很快形成了误解。",
      "当晚十点，两位主播开启连麦。气氛从一开始就紧绷，双方反复就「原话是什么」「剪辑是否恶意」争执，中间多次出现同时说话、抢麦的情况。",
      "有趣的是，连麦的在线人数随着争吵不断攀升，最高突破二十万。评论区也自然分成了两派，各自援引不同切片作为证据。",
      "整个对峙持续近两小时，双方都没有拿出决定性的完整录像。凌晨一点，两人先后下播，留下一个没有结论的夜晚。",
      "相比谁对谁错，这件事更值得讨论的是切片传播的生态：一段脱离语境的短视频，足以点燃一场持续数小时的公共对峙。",
    ],
    related: ["cg-20260910-02", "cg-20260903-09", "cg-20260901-06"],
  },
  {
    id: "cg-20260906-09",
    slug: "script-plagiarism-draft",
    title: "被指抄袭脚本，短视频博主放出创作手稿自证",
    summary:
      "一位剧情向博主被指抄袭他人脚本，对方晒出发布时间更早的视频作为证据。博主随后公布了分镜手稿与修改记录。",
    category: "collapse",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20editorial%20art%20of%20handwritten%20notebook%20pages%20and%20pencil%20lines%20on%20cream%20background%2C%20sage%20green%20and%20terracotta%20accents%2C%20paper%20texture%2C%20minimal%20magazine%20illustration&width=1200&height=800&seq=cg-art-09&orientation=landscape",
    author: "深扒小组",
    publishedAt: "2026-09-06 16:50",
    views: 118000,
    hot: false,
    tags: ["抄袭", "手稿", "自证"],
    timeline: [
      { time: "09-04", text: "另一位创作者发帖，称剧情结构与台词高度相似。" },
      { time: "09-05", text: "对比视频在多个平台传播，评论区出现两种声音。" },
      { time: "09-06 12:00", text: "博主公布分镜手稿与云文档修改历史。" },
      { time: "09-06 16:50", text: "发帖方表示会再做比对，暂不撤回指控。" },
    ],
    content: [
      "剧情类短视频的抄袭认定一直是难题：题材有限、桥段通用，相似的表达很难直接等同于抄袭。",
      "这次的争议源于一条对比视频。发帖者把两条视频的分镜并列，指出开场、转折与结尾的节奏几乎一致，且台词有多处重合。",
      "被指控的博主在两天后回应，公布了手写分镜稿与云文档的修改历史。记录显示脚本从初稿到成稿经历过多轮调整，时间跨度超过一周。",
      "不过，发帖方认为修改记录显示的仍是最终版本，无法证明核心创意的最初归属，表示会继续比对，暂不撤回指控。",
      "在创作领域，自证往往比指控更难。手稿、草稿与修改记录虽然能提供时间线索，但很难完全覆盖创意碰撞的可能性。",
      "这起争议最终大概率不会有明确结论，但它提醒了创作者：留存创作过程，是保护自己最实际的方式。",
    ],
    related: ["cg-20260908-04", "cg-20260902-01", "cg-20260905-05"],
  },
  {
    id: "cg-20260905-10",
    slug: "variety-debut-fail",
    title: "综艺首秀翻车，网红跨界到底难在哪",
    summary:
      "多位网红在近期综艺中担任常驻嘉宾，表现引发争议。有观众认为节奏跟不上，也有从业者指出是节目组定位问题。",
    category: "variety",
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20abstract%20illustration%20of%20a%20stage%20spotlight%20and%20empty%20director%20chair%20on%20cream%20background%2C%20coral%20red%20accents%2C%20editorial%20collage%2C%20grain%20texture%2C%20minimal%20magazine%20poster&width=1200&height=800&seq=cg-art-10&orientation=landscape",
    author: "瓜田观察员",
    publishedAt: "2026-09-05 20:10",
    views: 87000,
    hot: false,
    tags: ["综艺", "跨界", "首秀"],
    timeline: [
      { time: "08-15", text: "节目官宣新一季常驻阵容，包含三位网络创作者。" },
      { time: "09-03 20:00", text: "首期播出，三位网红的镜头表现引发讨论。" },
      { time: "09-04", text: "相关话题登上热搜，评论呈现两极。" },
      { time: "09-05", text: "节目组回应称剪辑会继续调整节奏。" },
    ],
    content: [
      "短视频与综艺是两套完全不同的语言体系。前者可以靠几十次拍摄找到最佳的三秒，后者需要在一次录制中完成连续反应。",
      "这也是三位网红在综艺首秀中显得吃力的原因。他们的单人镜头依旧有梗，但一旦进入多人互动，节奏明显跟不上长期做综艺的嘉宾。",
      "观众的反馈呈现两极：一部分人认为表现生硬、效果尴尬，另一部分人觉得真实感反而更讨喜。评论区的分歧本身，也成了话题的一部分。",
      "节目组回应称，后续会在剪辑上做节奏调整，让不同背景的嘉宾都有发挥空间。这个回应被解读为对剪辑责任的默认。",
      "跨界从来不是简单的曝光叠加。把一套内容语言迁移到另一套体系，需要的是适应而不是复制。",
    ],
    related: ["cg-20260909-03", "cg-20260907-06", "cg-20260903-09"],
  },
];

export const hotRank = [
  { id: "cg-20260910-01", title: "千万粉美食博主被曝情侣剧本", heat: "98.6万" },
  { id: "cg-20260908-04", title: "「乡村手艺人」被指团队包装", heat: "84.2万" },
  { id: "cg-20260910-02", title: "头部带货主播摔话筒深夜道歉", heat: "79.5万" },
  { id: "cg-20260907-07", title: "网红情侣三个月分手时间线", heat: "61.3万" },
  { id: "cg-20260909-03", title: "综艺同框被剪引发互相取关", heat: "52.8万" },
  { id: "cg-20260906-08", title: "连麦对喷两小时谁占理", heat: "44.1万" },
  { id: "cg-20260908-05", title: "9.9 元福袋成本不到 1 元", heat: "38.7万" },
  { id: "cg-20260906-09", title: "被指抄袭脚本后放出创作手稿", heat: "31.2万" },
];

export const marqueeTicker = [
  "美食博主被曝情侣剧本",
  "头部主播深夜道歉",
  "手艺人团队包装争议",
  "网红情侣三个月分手",
  "综艺同框被剪取关",
  "福袋成本争议复核中",
  "连麦对峙两小时",
  "手稿自证抄袭指控",
];

export const faqs = [
  {
    q: "吃瓜日报的瓜料一般多久更新一次？",
    a: "工作日全天滚动更新，重大事件会在两小时内补齐时间线与关键证据。首页「今日瓜」板块按发布时间倒序排列，方便按时间顺序围观。",
  },
  {
    q: "你们发布的内容都经过核实吗？",
    a: "我们只整理已经公开可查的信息，例如公开发布的动态、公开的声明与流传证据，并明确标注哪些内容尚未获得当事方确认。对于无法验证的传闻，我们不会作为结论呈现。",
  },
  {
    q: "为什么有的瓜只有时间线，没有明确结论？",
    a: "网红事件往往会经历多轮反转，过早下结论容易误伤当事人。我们的做法是把已知信息按时间排好，标注待确认的部分，把判断权交给读者。",
  },
  {
    q: "我可以投稿爆料吗？",
    a: "可以。站内「爆料投稿」入口支持匿名提交，建议附上公开可查的链接或截图。我们会先做核实，确认后再决定是否成稿。",
  },
  {
    q: "内容会不会涉及个人隐私？",
    a: "不会。我们不发布私人联系方式、身份信息与未经授权的私人影像。若当事人认为内容存在隐私风险，可以通过页面邮箱联系，我们会第一时间复核处理。",
  },
  {
    q: "可以联系你们处理侵权或更正吗？",
    a: "可以。通过关于我们页面的邮箱提交说明，附上相应依据，我们会在核实后补充说明或进行更正，并在原文标注更新记录。",
  },
];

export const testimonials = [
  {
    name: "阿柚",
    role: "三年老围观群众",
    text: "别的号只给结论，这里给时间线，谁先谁后一目了然，省得被带节奏。",
  },
  {
    name: "小满",
    role: "内容运营从业者",
    text: "把瓜整理成事件脉络这件事本身就很专业，我常拿来当案例看传播路径。",
  },
  {
    name: "老陈",
    role: "通勤地铁党",
    text: "五分钟看完一个瓜的来龙去脉，通勤一趟刚好，不耽误事。",
  },
  {
    name: "Nico",
    role: "MCN 商务",
    text: "标注哪些是已确认、哪些是待确认，这个习惯很加分，至少不会误伤合作方。",
  },
];